import React from 'react';
import { Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';

import App from './containers/App';

import RequireAuth from './components/RequireAuth';

import NotFoundPage from './containers/NotFoundPage';
import LoginPage from './containers/LoginPage';
import LoginPage2 from './containers/LoginPage2';
import ForgotPassPage from './containers/ForgotPassPage';
import RecoveryPassPage from './containers/RecoveryPassPage';

import Dashboard from './components/tracker/Dashboard';
import contextPage from './containers/contextPage';


import InvoiceCreate from './components/tracker/Invoice/InvoiceCreate';
import InvoiceCreateLot from './components/tracker/Invoice/InvoiceCreateLot';
import InvoiceSearch from './components/tracker/Invoice/InvoiceSearch';
import InvoiceList from './components/tracker/Invoice/InvoiceList';

import CompanyContainer from './components/tracker/Company/CompanyContainer';
import CompanyForm from './components/tracker/Company/CompanyForm';

import AccountContainer from './components/tracker/User/AccountContainer';
import AccountForm from './components/tracker/User/AccountForm';

import WorkflowContainer from './components/tracker/Flow/WorkflowContainer';
import WorkflowIncompleteList from './components/tracker/Flow/WorkflowIncompleteList';
import WorkflowForm from './components/tracker/Flow/WorkflowForm';


import WorkFlowList from './components/tracker/WorkFlow/WorkFlowList';
import WorkFlowCreate from './components/tracker/WorkFlow/WorkFlowCreate';

import CheckPage from './components/tracker/Check/CheckPage';
import InvoiceContainer from './components/tracker/Invoices/InvoiceContainer';
import InvoiceForm from './components/tracker/Invoices/InvoiceForm';

const RouteWithSubRoutes = route => (
  <Route
    path={route.path}
    render={props => (
      // pass the sub-routes down to keep nesting
      <route.component {...props} routes={route.routes} />
    )}
  />
);

const Routes = props => (
  <BrowserRouter>
    <Switch>
      <Route path="/login" component={LoginPage} />
      <Route path="/logout" component={LoginPage2} />
      <Route path="/forgot-pass" component={ForgotPassPage} />
      <Route path="/security/change-password" component={RecoveryPassPage} />
      <Route path="/context" component={contextPage} />

      <Route path="/invoice/list" render={routeProps => (<RequireAuth {...routeProps} component={InvoiceContainer} />)} />
      <Route path="/invoice/form" render={routeProps => (<RequireAuth {...routeProps} component={InvoiceForm} />)} />

      <Route path="/invoices/list" render={routeProps => (<RequireAuth {...routeProps} component={InvoiceList} />)} />
      <Route path="/invoices/form" render={routeProps => (<RequireAuth {...routeProps} component={InvoiceCreate} />)} />
      <Route path="/invoice/create" render={routeProps => (<RequireAuth {...routeProps} component={InvoiceCreate} />)} />
      <Route path="/invoice/lot" render={routeProps => (<RequireAuth {...routeProps} component={InvoiceCreateLot} />)} />
      <Route path="/invoice/search" render={routeProps => (<RequireAuth {...routeProps} component={InvoiceSearch} />)} />
      <Route path="/invoice/check" render={routeProps => (<RequireAuth {...routeProps} component={CheckPage} />)} />


      <Route path="/company/list" render={routeProps => (<RequireAuth {...routeProps} component={CompanyContainer} />)} />
      <Route path="/company/form" render={routeProps => (<RequireAuth {...routeProps} component={CompanyForm} />)} />
      <Route path="/company/form/:id" render={routeProps => (<RequireAuth {...routeProps} component={CompanyForm} />)} />

      <Route path="/account/list" render={routeProps => (<RequireAuth {...routeProps} component={AccountContainer} />)} />
      <Route path="/account/form" render={routeProps => (<RequireAuth {...routeProps} component={AccountForm} />)} />

      <Route path="/flow/list" render={routeProps => (<RequireAuth {...routeProps} component={WorkflowContainer} />)} />
      <Route path="/flow/incompleteList" render={routeProps => (<RequireAuth {...routeProps} component={WorkflowIncompleteList} />)} />
      <Route path="/flow/form" render={routeProps => (<RequireAuth {...routeProps} component={WorkflowForm} />)} />


      <Route path="/workflow/list" render={routeProps => (<RequireAuth {...routeProps} component={WorkFlowList} />)} />
      <Route path="/workflow/create" render={routeProps => (<RequireAuth {...routeProps} component={WorkFlowCreate} />)} />

      <Route path="/Dashboard" render={routeProps => (<RequireAuth {...routeProps} component={Dashboard} />)} />

      <Route path="/" component={LoginPage} />
    </Switch>
  </BrowserRouter>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js